/**
 * 01/2014: Movemos esta función a shared porque usamos librerías compatibles con navegadores actuales
 *          (dejamos en el server lo propio de Nodejs como Buffer > daría error usarlo en la parte del cliente)
 *
 * COMPATIBLE con: decodeURIComponent(escape(atob(str)))  * se puede sustituir perfectamente *
 *
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_.22unicode_problem.22
 * Solution #2 – rewriting atob() and btoa() using TypedArrays and UTF-8
 *
 * @param {*} str
 * @param {*} encoding default UTF-8
 * @returns
 */
export function decodeB64WithEncoding(str, encoding) {
  const textArray = base64DecToArr(str);
  // Protegemos encoding='' is not supported
  const decoder = new TextDecoder(encoding || 'utf-8');
  return decoder.decode(textArray);
}

function b64ToUint6(nChr) {
  if (nChr > 64 && nChr < 91) {
    return nChr - 65;
  } else if (nChr > 96 && nChr < 123) {
    return nChr - 71;
  } else if (nChr > 47 && nChr < 58) {
    return nChr + 4;
  } else if (nChr === 43) {
    return 62;
  } else if (nChr === 47) {
    return 63;
  }

  return 0;
}

function base64DecToArr(sBase64, nBlocksSize) {
  const sB64Enc = sBase64.replace(/[^A-Za-z0-9+/]/g, '');
  const nInLen = sB64Enc.length;
  const nOutLen = nBlocksSize ? Math.ceil(((nInLen * 3 + 1) >> 2) / nBlocksSize) * nBlocksSize : (nInLen * 3 + 1) >> 2;
  const taBytes = new Uint8Array(nOutLen);

  let nMod3;
  let nMod4;
  let nUint24 = 0;
  let nOutIdx = 0;
  for (let nInIdx = 0; nInIdx < nInLen; nInIdx++) {
    nMod4 = nInIdx & 3;
    nUint24 |= b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << (6 * (3 - nMod4));
    if (nMod4 === 3 || nInLen - nInIdx === 1) {
      nMod3 = 0;
      while (nMod3 < 3 && nOutIdx < nOutLen) {
        taBytes[nOutIdx] = (nUint24 >>> ((16 >>> nMod3) & 24)) & 255;
        nMod3++;
        nOutIdx++;
      }
      nUint24 = 0;
    }
  }

  return taBytes;
}
